<template>
  <!-- チャットダイアログヘッダー -->
  <div class="header-form"
    :class="{'open-height': isOpenForm&&!widgetData.scout_flg}">
    <button style="display: flex; justify-content: center; align-items: center;" class="open-form-button" @click="setOpenForm(!isOpenForm)">
      <div style="display: flex; font-size: 16px;" v-if="widgetData.scout_flg"><p class="shake-msg">✉️</p>あなたにスカウトが届いてます！</div>
      <div style="display: flex; font-size: 16px;" v-else-if="headerType === 1 || headerType === 2">{{isHeaderTitle}}</div>
      <div style="display: flex; font-size: 16px;" v-else-if="!widgetData.scout_flg"><p class="shake-msg">👋</p>ご興味を持たれた方はこちら！</div>
      <span class="mdi mdi-chevron-down mdi-48px" v-if="!isOpenForm&&!widgetData.scout_flg"></span>
      <span class="mdi mdi-chevron-up mdi-48px" v-if="isOpenForm&&!widgetData.scout_flg"></span>
    </button>
    <transition name="slide-down">
      <div class="subscribe-form-wrapper">
        <!-- ご興味を持たれた方はこちら！ -->
        <article class="subscribe-form" style="width: 100%; min-width: 320px;" v-if="isOpenForm && !widgetData.scout_flg && headerType !== 2">
          <div class="apply-body" v-if="widgetData">
            <div class="apply-form" v-if="widgetData.subscribe_is_name">
              <span class="require" v-if="widgetData.subscribe_required_name">*</span>
              <span class="require -none" v-else>*</span>
              <p class="apply-title">お名前</p>
              <input class="input is-small" placeholder="例：山田太郎" v-model="skName" maxlength="200"/>
            </div>
            <div class="apply-form" v-if="widgetData.subscribe_is_name_phonetic">
              <span class="require" v-if="widgetData.subscribe_required_name_phonetic">*</span>
              <span class="require -none" v-else>*</span>
              <p class="apply-title">フリガナ</p>
              <input class="input is-small" placeholder="例：ヤマダタロウ" v-model="skNamePhonetic" maxlength="200"/>
            </div>
            <div class="apply-form" v-if="widgetData.subscribe_is_email">
              <span class="require" v-if="widgetData.subscribe_required_email">*</span>
              <span class="require -none" v-else>*</span>
              <p class="apply-title">Email</p>
              <input class="input is-small" placeholder="例：taro-yamada@xxx.yyy.jp" v-model="skEmail" type="email" maxlength="254"/>
            </div>
            <div class="apply-form" v-if="widgetData.subscribe_is_tel">
              <span class="require" v-if="widgetData.subscribe_required_tel">*</span>
              <span class="require -none" v-else>*</span>
              <p class="apply-title">TEL</p>
              <input class="input is-small" placeholder="例:09012345678" v-model="skTel" type="tel"  maxlength="20"/>
            </div>
            <div class="apply-form" v-if="widgetData.subscribe_is_address">
              <span class="require" v-if="widgetData.subscribe_required_address">*</span>
              <span class="require -none" v-else>*</span>
              <p class="apply-title">住所</p>
              <div style="display: flex; width: -webkit-fill-available;">
                <b-select size="is-small" style="margin-bottom: 4px;" v-model="skPrefectures">
                  <option v-for="pre in prefectures" :key="pre" :value="pre">
                    {{pre}}
                  </option>
                </b-select>
                <input class="input is-small" placeholder="例:東京都港区西新橋X-XX" v-model="skAddress" maxlength="300"/>
              </div>
            </div>
            <div class="apply-form" v-if="widgetData.subscribe_is_birth">
              <span class="require" v-if="widgetData.subscribe_required_birth">*</span>
              <span class="require -none" v-else>*</span>
              <p class="apply-title">生年月日</p>
              <b-datepicker
                style="width: 100%;"
                size="is-small"
                :show-week-number="false"
                placeholder="生年月日"
                icon="calendar-today"
                :day-names="['日', '月', '火', '水', '木', '金', '土']"
                :month-names="['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月']"
                v-model="skBirth">
              </b-datepicker>
            </div>
            <div class="apply-form" v-if="widgetData.subscribe_is_sex">
              <span class="require" v-if="widgetData.subscribe_required_sex">*</span>
              <span class="require -none" v-else>*</span>
              <p class="apply-title">性別</p>
              <b-select size="is-small" v-model="skSex" style="width: 100%">
                <option v-for="(s, key) in sexTypes" :value="key" :key="key + '-sexType'">
                    {{ s }}
                </option>
              </b-select>
            </div>
            <div class="apply-form" v-if="widgetData.subscribe_is_message">
              <span class="require" v-if="widgetData.subscribe_required_message">*</span>
              <span class="require -none" v-else>*</span>
              <p class="apply-title">備考</p>
              <b-select size="is-small" v-model="skMsg" style="width: 100%">
                <option
                  style="font-size: 12px;"
                  v-for="(i, index) in widgetData.subscribe_list_message.msg_list"
                  :value="i"
                  :key="index + '-msg'">
                  {{ i }}
                </option>
              </b-select>
            </div>
            <hr>
            <div class="button-container">
              <button class="button is-primary is-fullwidth"
                @click="subscribe()"
                :disabled="isDisabled">
                <span class="mdi mdi-send" style="margin-right: 6px;"></span>
                送信
              </button>
            </div>
            <div class="apply-form auto">
              <a class="privacy-policy" href="https://hr-monster.io/privacy/" target="_blank" rel="noopener">プライバシーポリシー</a>
            </div>
          </div>
        </article>
        <!-- お問い合わせ -->
        <article class="subscribe-form" style="width: 100%; min-width: 320px;" v-if="isOpenForm && !widgetData.scout_flg && headerType === 2">
          <div class="apply-form">
            <span class="require">*</span>
            <p class="apply-title">お名前</p>
            <input class="input is-small" placeholder="例：山田太郎" v-model="contact.name" maxlength="200"/>
          </div>
          <div class="apply-form">
            <span class="require">*</span>
            <p class="apply-title">Email</p>
            <input class="input is-small" placeholder="例：taro-yamada@xxx.yyy.jp" v-model="contact.user_email" type="email" maxlength="254"/>
          </div>
          <div class="apply-form">
            <span class="require">*</span>
            <p class="apply-title">TEL</p>
            <input class="input is-small" placeholder="例：09012345678（ハイフン無し）" v-model="contact.user_tel" type="tel"  maxlength="20"/>
          </div>
          <div style="margin-top: 24px;">
            <div style="text-align: left; font-size: 13px; margin-bottom: 8px; display: flex">
              <span class="require">*</span>
              <p>内容</p>
            </div>
            <div class="control">
              <textarea class="textarea is-small" rows="8" placeholder="例：---についてお教えいただけませんでしょうか？" v-model="contact.content" style="min-width: 100%; white-space: pre-wrap;" maxlength="300" textarea></textarea>
            </div>
          </div>
          <button class="button is-primary is-fullwidth" style="margin-top: 16px;" @click="sendContact">
            <span class="mdi mdi-send" style="margin-right: 6px;"></span>
            送信
          </button>
          <div class="apply-form auto">
            <a class="privacy-policy" href="https://hr-monster.io/privacy/" target="_blank" rel="noopener">プライバシーポリシー</a>
          </div>
        </article>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    color: {
      type: Object,
      required: true
    },
    isOpenForm: {
      type: Boolean,
      required: true
    },
    widgetData: {
      type: Object,
      required: true,
    },
    headerType: {
      type: Number,
      required: true,
    },
    headerTitle: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      sexTypes  : ['', '男性', '女性', '選択しない'],
      skName: null,
      skEmail: null,
      skTel: null,
      skNamePhonetic: null,
      skAddress: null,
      skBirth: null,
      skSex: 0,
      skMsg: null,
      skPrefectures: null,
      contact: {
        name: '',
        user_email: '',
        user_tel: '',
        content: ''
      },
      // TODO: どこかにまとめておきたい
      prefectures: [
        '北海道',
        '青森県',
        '岩手県',
        '宮城県',
        '秋田県',
        '山形県',
        '福島県',
        '茨城県',
        '栃木県',
        '群馬県',
        '埼玉県',
        '千葉県',
        '東京都',
        '神奈川県',
        '新潟県',
        '富山県',
        '石川県',
        '福井県',
        '山梨県',
        '長野県',
        '岐阜県',
        '静岡県',
        '愛知県',
        '三重県',
        '滋賀県',
        '京都府',
        '大阪府',
        '兵庫県',
        '奈良県',
        '和歌山県',
        '鳥取県',
        '島根県',
        '岡山県',
        '広島県',
        '山口県',
        '徳島県',
        '香川県',
        '愛媛県',
        '高知県',
        '福岡県',
        '佐賀県',
        '長崎県',
        '熊本県',
        '大分県',
        '宮崎県',
        '鹿児島県',
        '沖縄県',
        'その他',
      ]
    }
  },
  computed: {
    isDisabled () {
      return (
        (this.widgetData.subscribe_required_name          && this.widgetData.subscribe_is_name          ? (!this.skName                     && this.widgetData.subscribe_is_name)          : false) ||
        (this.widgetData.subscribe_required_name_phonetic && this.widgetData.subscribe_is_name_phonetic ? (!this.skNamePhonetic             && this.widgetData.subscribe_is_name_phonetic) : false) ||
        (this.widgetData.subscribe_required_email         && this.widgetData.subscribe_is_email         ? (!this.skEmail                    && this.widgetData.subscribe_is_email)         : false) ||
        (this.widgetData.subscribe_required_tel           && this.widgetData.subscribe_is_tel           ? (!this.skTel                      && this.widgetData.subscribe_is_tel)           : false) ||
        (this.widgetData.subscribe_required_email         && this.widgetData.subscribe_is_email         && !this.skEmail ? (this.skEmail.indexOf('@') == -1 && this.widgetData.subscribe_is_email)         : false) ||
        (this.widgetData.subscribe_required_birth         && this.widgetData.subscribe_is_birth         ? (!this.skBirth                   && this.widgetData.subscribe_is_birth)         : false) ||
        (this.widgetData.subscribe_required_address       && this.widgetData.subscribe_is_address       ? ((!this.skAddress || !this.skPrefectures) && this.widgetData.subscribe_is_address)       : false) ||
        (this.widgetData.subscribe_required_sex           && this.widgetData.subscribe_is_sex           ? (!this.skSex                     && this.widgetData.subscribe_is_sex)           : false) ||
        (this.widgetData.subscribe_required_message       && this.widgetData.subscribe_is_message       ?  !this.skMsg                                                                     : false)
      )
    },
    isHeaderTitle () {
      if (this.headerTitle === '' && this.headerType == 1) {
        return 'ご応募はこちら！'
      } else if (this.headerTitle === '' && this.headerType == 2) {
        return 'お問い合わせはこちら！'
      } else {
        return(this.headerTitle)
      }
    }
  },
  methods: {
    setOpenForm (flg) {
      this.$emit('setOpenForm', flg)
    },
    subscribe () {
      this.$emit('subscribe', {
        skName: this.skName,
        skEmail: this.skEmail,
        skTel: this.skTel,
        skNamePhonetic: this.skNamePhonetic,
        skAddress: (this.skPrefectures === 'その他' ? '' : this.skPrefectures) + this.skAddress,
        skBirth: this.skBirth,
        skSex: this.skSex,
        skMsg: this.skMsg,
      })
    },
    sendContact () {
      this.$emit('sendContact', this.contact)
    }
  }
}
</script>

<style lang="scss" scoped>
.header-form {
  transition: 0.5s;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 50px;
  color: white;
  background: rgba(0, 0, 0, 0.8);
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}
.open-height {
  height: 100%;
  width: 100%;
  position: absolute;
  z-index: 100;
  flex-wrap: wrap;
}
.open-form-button {
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 900;
  background: rgba(0, 0, 0, 0);
  color: white;
  border: none;
  cursor: pointer;
  outline: none;
  width: calc(100% - 10px);
  height: 55px;
}
.slide-down-enter, .slide-down-enter-active {
  animation: slide-down-anim .4s;
  transform-origin: top;
}
.slide-down-leave-to, .slide-downg-leave-active {
  animation: slide-down-anim .4s reverse;
  transform-origin: top;
}
@keyframes slide-down-anim {
  0% {
    transform: scale(1, 0);
  }
  25% {
    transform: scale(1, 0);
  }
  100% {
    transform: scale(1, 1);
  }
}
.subscribe-form {
  width: 90%;
  padding: 15px;
  color: black;
  background: white;
  overflow-y: auto;
  margin: auto;
  height: calc(100vh - 160px);
}
.subscribe-form::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  visibility: hidden;
}
.apply-body {
  background: #fff;
  margin-top: 24px;
}
.apply-form {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
  &.auto {
    height: auto;
  }
}
.apply-title {
  width: 100px; font-size: 13px; text-align: left;
}
.privacy-policy {
  width: 100%; font-size: 12px; text-align: right;
}
.require {
  color: red; margin-right: 2px;
  &.-none {
    visibility: hidden;
  }
}
.button-container {
  margin-top: 16px;
}
.shake-msg {
  margin-right: 6px;
  animation: shake-msg-anim 1s infinite;
}
@keyframes shake-msg-anim {
  0% {
    transform: rotateZ(-20deg);
  }
  50% {
    transform: rotateZ(20deg);
  }
  100% {
    transform: rotateZ(-20deg);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/ChatWidgetDialog/organisms/ChatDialogHeader.vue